import { get } from 'services/api/base-portal-api';

import { DiscoverMerchantsResponse } from './types-get-merchants-discovery';

export function getMerchantsDiscovery(): Promise<DiscoverMerchantsResponse> {
  return get('v1/pos/merchants-discovery').json();
}
